<template>
    <div class="white-bg">
        <top-carousel></top-carousel>
        <div class="contact-content container">
            <div class="clearfix">
                <div class="left-card">
                    <div class="card-title">Call Us</div>
                    <div class="card-subtitle">合作咨询联系方式</div>
                    <ul>
                        <li>
                            <img
                                src="../../../../assets/img/contact/dklls.png"
                                alt=""
                            />
                            <dl>
                                <dd>
                                    服务热线：<a href="tel:029-68255490"
                                        >029-68255490</a
                                    >
                                </dd>
                                <dd>
                                    技术咨询：<a href="tel:029-68255491"
                                        >029-68255491转816</a
                                    >
                                </dd>
                            </dl>
                        </li>

                        <li>
                            <img
                                src="../../../../assets/img/contact/strkjed.png"
                                alt=""
                            />
                            <dl>
                                <dt>Email Address:</dt>
                                <dd>
                                    <a href="mailto:tiant@kingwings.net"
                                        >tiant@kingwings.net</a
                                    >
                                </dd>
                            </dl>
                        </li>
                        <li>
                            <img
                                src="../../../../assets/img/contact/sfdo.png"
                                alt=""
                            />
                            <dl>
                                <dt>公司地址</dt>
                                <dd>西安市高新区锦业路绿地领海B座11201室</dd>
                            </dl>
                        </li>
                    </ul>
                </div>
                <el-form
                    label-width="0px"
                    :rules="rules"
                    :model="myForm"
                    ref="form"
                    class="right-form"
                >
                    <el-form-item label="" prop="F_ContactPerson">
                        <el-input
                            v-model="myForm.F_ContactPerson"
                            maxlength="20"
                            placeholder="请输入联系人"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="" prop="F_PhoneNumber">
                        <el-input
                            v-model="myForm.F_PhoneNumber"
                            maxlength="20"
                            placeholder="请输入手机号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="" prop="F_Email">
                        <el-input
                            v-model="myForm.F_Email"
                            maxlength="20"
                            placeholder="请输入邮箱"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="" prop="F_Description">
                        <el-input
                            type="textarea"
                            v-model="myForm.F_Description"
                            maxlength="200"
                            show-word-limit
                            placeholder="请输入意向说明"
                            rows="4"
                        ></el-input>
                    </el-form-item>
                    <div>
                        <el-button
                            type="danger"
                            size="medium"
                            class="btn-block"
                            @click="submitData"
                        >
                            提交
                        </el-button>
                    </div>
                </el-form>
            </div>
            <!--百度地图容器-->
            <baidu-map
                class="bm-view"
                :center="center"
                :zoom="zoom"
                :scroll-wheel-zoom="true"
            >
                <bm-marker
                    :position="{
                        lng: 108.891949,
                        lat: 34.198929,
                    }"
                    :dragging="true"
                    animation="BMAP_ANIMATION_BOUNCE"
                >
                </bm-marker>
                <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT" />
            </baidu-map>
        </div>
    </div>
</template>

<script>
import Http from '../../../../service/http'
import validator from '../../../../validator'
export default {
    data() {
        return {
            center: { lng: 108.891949, lat: 34.198929 },
            zoom: 12,
            myForm: {},
            rules: {
                F_ContactPerson: [
                    {
                        required: true,
                        message: '请输入联系人',
                        trigger: 'blur',
                    },
                ],
                F_PhoneNumber: validator.mobileValidator,
                F_Email: validator.emailValidator,
                F_Description: [
                    {
                        required: true,
                        message: '请输入意向说明',
                        trigger: 'blur',
                    },
                ],
            },
        }
    },
    methods: {
        submitData() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.saveData()
                }
            })
        },
        async saveData() {
            let res = await Http['submitContactUs'](this.myForm, false)
            if (res) {
                this.$message.success('提交数据成功!')
                this.$refs.form.resetFields()
            }
        },
    },
}
</script>

<style scoped lang="less">
.contact-content {
    background: #fff;
    padding: 32px;
    position: relative;
    .left-card {
        width: 40%;
        float: left;
        border: 1px solid #ddd;
        padding: 15px;
        .card-title {
            color: #282828;
            font-size: 18px;
            line-height: 1.5;
        }
        .card-subtitle {
            color: #061538;
            font-size: 28px;
            line-height: 1.5;
        }
        ul > li {
            height: 70px;
            & + li {
                border-top: 1px solid rgba(222, 226, 230, 1);
            }
            img {
                margin-right: 15px;
            }
            dl {
                display: inline-block;
                position: relative;
                top: 13px;
                color: #061538;
                dt {
                    font-size: 16px;
                }
                dd {
                    font-size: 14px;
                    a {
                        color: #061538;
                    }
                }
            }
        }
    }
    .right-form {
        float: right;
        width: 60%;
        padding-left: 32px;
    }
}
.bm-view {
    margin-top: 32px;
    height: 348px;
}
/deep/ .el-form-item__error {
    padding-top: 2px;
}
</style>
